<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <luma-empty>
<b-card>
  <b-button class="col-12"
            @click="createZone = !createZone"
            variant="outline-success">
    {{createZone ? 'Abbrechen' : 'Neue Zone erstellen'}}
  </b-button>
</b-card>
    <b-card>
      <luma-create-zone-dns v-if="createZone"></luma-create-zone-dns>

      <luma-table v-if="!createZone"
                  url="dns/zones"
                  :columns="columns"
                  :model="zone"
                  :order="order" >
        <template v-slot:actions="slotProps">
          <b-button variant="white small"
                    size="xs"
                    :to="{name: 'dns-single', params: { name: slotProps.item.name }}">
            Ansehen
          </b-button>
        </template>
      </luma-table>
    </b-card>
  </luma-empty>
</template>

<script>
  import LumaEmpty from "@/layout/LumaEmpty";
  import LumaDatatable from "@/components/LumaDatatable";
  import {NameserverZone} from "@/store/models/dns/nameserver_zone";
  import LumaCreateZoneDns from "@/components/dns/list_dns/luma-create-zone-dns";

  export default {
    name: "luma-dns-list",
    components: {
      LumaCreateZoneDns,
      LumaEmpty,
      'luma-table': LumaDatatable
    },
    data: () => ({
      createZone:false,
      columns: [
        {
          key: 'name',
          column: 'name',
          filter: true,
          order: true
        },
        {
          key: 'serial',
          column: 'serial',
          filter: true,
          order: true
        },
        {
          key: 'ttl',
          column: 'ttl',
          filter: true,
          order: true
        },
        {
          key: 'updated_at',
          column: 'updated_at',
          filter: true,
          order: true
        },
        {
          key: 'user',
          column: 'user',
          filter: true,
          order: true
        },
        {
          key: 'actions',
          column: 'actions',
          filter: false,
          order: false,
          slot: true
        }
      ],
      order: {
        'name': 'asc'
      },
      zone: NameserverZone
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dns/list_dns/luma-dns-list.vue